import { useTranslation } from 'react-i18next'

const AboutUsSection = () => {
	const { t } = useTranslation()

	return (
		<section className='about-us-section'>
			<div className='wrapper'>
				<h1>
					{t('about_us.title')}{' '}
					<span className='text-[#65a665] pl-[10px]'>{t('about_us.us')}</span>
				</h1>

				<div className='description'>
					<div className='text'>
						<p>{t('about_us.description_1')}</p>
						<p>{t('about_us.description_2')}</p>
						<p>{t('about_us.description_3')}</p>
						<p>{t('about_us.description_4')}</p>
					</div>

					<img src='/team.jpg' alt='team.jpg' />
				</div>
			</div>
		</section>
	)
}

export default AboutUsSection
